module.exports = __webpack_public_path__ + "img/fx_banner.2786f6db.jpg";